import { render, staticRenderFns } from "./DetailsItemFullWidth.vue?vue&type=template&id=6a95b158&scoped=true"
import script from "./DetailsItemFullWidth.vue?vue&type=script&lang=js"
export * from "./DetailsItemFullWidth.vue?vue&type=script&lang=js"
import style0 from "./DetailsItemFullWidth.vue?vue&type=style&index=0&id=6a95b158&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a95b158",
  null
  
)

export default component.exports